module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_9006.d96f80b2.png";